import { useMemo } from 'react';

import { useTranslation } from 'react-i18next';

import { GridColDef, GridValidRowModel } from '@mui/x-data-grid-pro';
import { DutyHourTypeDto } from 'components/types';

export const useGetSpecialLeaveColumns = ({
  specialLeavesRows,
  dhtOptions
}) => {
  const { t: tCommon } = useTranslation('common');
  const { t } = useTranslation('common', {
    keyPrefix: 'adminPortal.cla.specialLeave.settings'
  });

  return useMemo<GridColDef<GridValidRowModel>[]>(
    () => [
      {
        field: 'special_leave_importCode',
        headerName: tCommon('costCenterDetail.importCode'),
        width: 120
      },
      {
        field: 'special_leave_dutyHourTypeId',
        headerName: tCommon('dutyHourType'),
        flex: 1,
        valueGetter: (_, row) => {
          const dht = dhtOptions?.find((dht: DutyHourTypeDto) => {
            return dht.dutyTypeId === row.special_leave_dutyHourTypeId;
          });
          return dht ? dht.description : '';
        }
      },
      {
        field: 'special_leave_processAsNegative',
        headerName: t('positiveNegative'),
        width: 160,
        align: 'center',
        headerAlign: 'center',
        valueFormatter: (params) => {
          if (params === null || params === undefined) return '';
          return params === true ? t('NEGATIVE') : t('POSITIVE');
        }
      },
      {
        field: 'special_leave_percentage',
        headerName: tCommon('percentage'),
        width: 120,
        align: 'center',
        headerAlign: 'center'
      },
      {
        field: 'special_leave_period',
        headerName: t('weeklyOrMonthly'),
        width: 160,
        align: 'center',
        headerAlign: 'center',
        valueFormatter: (params) => {
          return params === 'WEEKLY' || params === 'MONTHLY' ? t(params) : '';
        }
      }
    ],
    [specialLeavesRows, t, dhtOptions]
  );
};
